module.exports = __webpack_public_path__ + "static/media/right-quotes.d62c9e16.svg";